import { getWhatsAppUrl } from "@/lib/contact";
import { contactSection } from "@/i18n/contactSection";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { processContent } from "@/i18n/processContent";
import SectionHeading from "@/components/SectionHeading";

const HowWeWork = () => {
  const { lang } = useLanguage();
  const copy = processContent[lang];

  return (
    <section id="process" data-testid="process-section" className="scroll-mt-28 bg-mist/40 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <SectionHeading eyebrow={copy.eyebrow} title={copy.title} sub={copy.sub} />
        <ol className="mt-10 grid gap-5 md:grid-cols-3">
          {copy.steps.map((step, index) => (
            <li key={step.title} className="rounded-3xl border border-line bg-white p-7">
              <span aria-hidden="true" className="text-sm font-bold tabular-nums text-sage-deep" dir="ltr">0{index + 1}</span>
              <h3 className="mt-4 text-lg font-bold text-charcoal">{step.title}</h3>
              <p className="mt-3 text-sm leading-7 text-graphite/80">{step.desc}</p>
            </li>
          ))}
        </ol>
        <div className="mt-8 flex justify-center">
          <a href={getWhatsAppUrl(contactSection[lang].whatsappMessage)} target="_blank" rel="noopener noreferrer" data-testid="process-contact-cta" className="inline-flex min-h-12 items-center gap-2 rounded-full bg-charcoal px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-graphite focus-visible:ring-2 focus-visible:ring-sage focus-visible:ring-offset-4">
            {copy.cta}<ArrowUpRight className="size-4 rtl:-scale-x-100" aria-hidden="true" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default HowWeWork;
